






























































































import PagePopup from '@/components/popup/page/PagePopup.vue'
import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {Card, Link} from 'element-ui'
import Loading from '@/components/Loading.vue'
import FooterButton from '@/components/FooterButton.vue'
import browser from 'browser-detect'

const biz = namespace('biz')
const certificates = namespace('certificates')
const layout = namespace('layout')
const gtm = namespace('gtm')

@Component({
  components: {
    FooterButton,
    PagePopup,
    Loading,
    TitleAndMessage,
    [Card.name]: Card,
    [Link.name]: Link,
  },
})

export default class CertificateRegistrationPopup extends Mixins(Translation, Assets) {
  @biz.State('isCorporate') isCorporate
  @layout.Mutation('updateError') updateError
  @layout.Mutation('setProgress') setProgress: (percentage: number) => void
  @certificates.Action('getRegisterCode') getRegisterCode
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  @Prop({default: 'terms.certificates'}) translation: string
  @Prop({default: false}) isOpen: boolean
  @Prop({default: null, type: String}) serviceName: ''

  loading: boolean = true
  isOpenGuide: boolean = true
  code: string = ''

  get keepCertCenterLink(): string {
      return process.env.VUE_APP_KEEP_CERT_CENTER_URL
  }

  get spinner() {
    /**
     * 공동인증서 등록 코드 생성 되면 loading 제거
     */
    if(this.code !== null) {
      this.loading = false
    } else {
      this.loading = true
    }
    return this.loading
  }

  get certGuide() {
    const {isCorporate} = this
    const guide = {
      title: isCorporate ? '기업용 공동인증서' : '대표자의 개인 공동인증서',
      des: isCorporate
        ? '법인 사업자등록번호로 발급한 은행거래용/범용 공동인증서'
        : '대표자 주민등록번호로 발급한 은행거래용/범용 공동인증서',
      comment: '*발급 기관: yessign(금융결제원)'
    }
    return guide
  }

  get descriptions() {
    const des = {
      1: '더낸세금 홈페이지 > "공동인증센터" 접속',
      2: '설치 프로그램 확인 후 나타나는 화면에 휴대폰의 인증코드 5자리 입력',
      3: '공동인증서 선택 후 암호 입력',
    }
    return des
  }

  get services() {
    const {serviceName} = this
    if(!serviceName) return []
    if(['hometax', 'giro', 'popbill', 'ei'].indexOf(serviceName) > -1) {
      return [{serviceName}]
    }
    return [{serviceName: 'bank', bankCode: serviceName}]
  }

  get registerHeader() {
    const {serviceName} = this
    if(!serviceName) return ''
    if(['hometax', 'giro', 'popbill', 'ei'].indexOf(serviceName) > -1) {
      return this.ts(`${serviceName}`)
    }
    return `${this.ts(`bank-codes.${this.serviceName}`)}${this.ts('bank')}`
}

  @Watch('isOpen', {immediate: true})
  __isOpen(value: boolean) {
    this.isOpenGuide = true
      if(value) {
      // check windows pc
      const result = browser()
      const osType = `${result.os}`
      if(osType.toLowerCase().indexOf('win') > -1) {
        this.setProgress(20)
        this.requestCode()
        setTimeout(() => {
          this.setProgress(100)
          this.isOpenGuide = false
        }, 4000)
      } else {
        location.href = 'https://cert.overtax.co.kr'
      }
    }
  }

  onClosePopup() {
    this.$emit('on-after-close')
  }

  requestCode() {
    const {services} = this
    this.getRegisterCode({services})
      .then((data) => {
        this.code = data
        this.logEventWithGroups({
          eventType: 'view_auth_code',
          eventProperties: {
            'biz_entity': this.isCorporate ? 'corporate' : 'private',
            'code': this.code,
          }
        })
      })
      .catch((error) => {
        this.updateError({
          id: 'get-code',
          message: `${this.ts('code')}를 가져오는데 실패하였습니다.`,
          action: {
            kind: 'refresh',
          },
        })
        throw error
      })
  }

}
